import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
// Fuentes self-hosted: se empaquetan en el CSS de la app y eliminan la petición
// bloqueante a fonts.googleapis.com. Sólo los pesos realmente usados.
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "lite-youtube-embed";
import "./index.css";
import "./i18n";

// Quitamos los meta tags estáticos del prerender marcados con data-rh="true"
// ANTES de montar React. react-helmet-async no reconcilia con tags inyectados
// por nuestro script de prerender (no por su propio SSR), así que añadiría
// duplicados (canonical, og:url, etc.). Al borrarlos aquí, Helmet queda como
// única fuente en cliente. Los crawlers sin JS siguen viendo los estáticos.
if (typeof document !== "undefined") {
  document.head.querySelectorAll('[data-rh="true"]').forEach((n) => n.remove());
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

